let env = process.env.REACT_APP_ENVIRONMENT;
let backend_dev_url = process.env.REACT_APP_BACKEND_DEV_URL;
//env = "local";
let config;

//Helper function to replace placeholders in a JSON object
const replacePlaceholders = (obj, placeholder, replacement) => {
    return JSON.parse(JSON.stringify(obj).replace(new RegExp(placeholder, 'g'), replacement));
}
switch (env) {
    case 'dev':
        config = require('./config/config.dev.json');
        break;
    case 'sit':
        config = require('./config/config.sit.json');
        break;
    case 'sandbox':
        config = require('./config/config.sandbox.json');
        break;
    case 'prod':
        config = require('./config/config.prod.json');
        break;
    case 'dr':
        config = require('./config/config.dr.json');
        break;
    case 'perf':
        config = require('./config/config.perf.json');
        break;
    case 'local':
        config = replacePlaceholders(require('./config/config.local.json'), '{{BASE_URL}}', backend_dev_url);
        break;
    default:
        throw new Error(`no env:${env}`)

}

// ============================================================================
// DYNAMIC DOMAIN DETECTION - Fix for multi-domain support
// ============================================================================
// Problem: Hardcoded domain URLs in config files cause CORS errors when
// accessing from different domains (carelon.com vs elevancehealth.com)
//
// Solution: Detect current domain and replace all hardcoded domains with
// current domain at runtime
// ============================================================================

const currentHostname = window.location.hostname;
const protocol = window.location.protocol;
const currentDomain = `${protocol}//${currentHostname}`;

//console.log('=== FHIR API Documentation - Config Domain Detection ===');
//console.log('Current hostname:', currentHostname);
//console.log('Current domain:', currentDomain);
//console.log('Environment:', env);

// Replace hardcoded domain with current domain in all URL fields
const updatedConfig = {};
for (const key in config) {
    if (typeof config[key] === 'string' && config[key].startsWith('http')) {
        // Only replace domain for internal API URLs (not external HL7 URLs)
        if (config[key].includes('totalview.healthos')) {
            try {
                const urlObj = new URL(config[key]);
                const updatedUrl = `${currentDomain}${urlObj.pathname}`;
                updatedConfig[key] = updatedUrl;
                //console.log(`Updated ${key}:`, updatedUrl);
            } catch (e) {
                // If URL parsing fails, keep original
                updatedConfig[key] = config[key];
            }
        } else {
            // Keep external URLs unchanged (HL7 implementation guides, etc.)
            updatedConfig[key] = config[key];
        }
    } else {
        updatedConfig[key] = config[key];
    }
}

//console.log('=== End FHIR API Documentation - Config Domain Detection ===');

export default updatedConfig;